export default "__VITE_ASSET__cc61f21b__"